export enum GameStage {
    Unknown,
    MainMenu,
    LoadGame,
    SelectCampaign,
    SelectNoOfPlayers,
    SelectInvestigator,
    SelectDifficulty,
    SummaryScreen,
    CampaignIntro,
    ScenarioIntro,
    ScenarioPlay,
    ScenarioOutro,
    VictoryDisplay,
    ScenarioSummary,
    ShowCampaignLog,
}